@if (crossSell(); as crossSell) {
<div class="product-cross-sell">
    @if (crossSell.perfectPartner?.total) {
    <h-product-page-grid
        id="product-page-cross-sell-perfect-partner"
        [crossSellingProducts]="crossSell.perfectPartner.items"
        [gridTitle]="'perfect_partner'">
        <ng-container i18n="@@node--hermes-product-display-default.the-perfect-partner">
            The Perfect Partner
        </ng-container>
    </h-product-page-grid>
    } @if (crossSell.keepExploring?.total) {
    <h-product-page-grid
        id="product-page-cross-sell-keep-exploring"
        [crossSellingProducts]="crossSell.keepExploring.items"
        [gridTitle]="'keep_exploring'">
        <ng-container i18n="@@node--hermes-product-display-default.keep-exploring"> Keep exploring </ng-container>
    </h-product-page-grid>
    }
</div>
}
